import { useFlags } from 'launchdarkly-react-client-sdk'

const LDComponent = ({ children }) => {
  const flags = useFlags()
  return children({ flags })
}

export default LDComponent
